// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invoice-container {
    width: 80%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 5px;
    background-color: #f9f9f9;
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.invoice-header div {
    flex: 1 1;
    margin-right: 10px;
}

.invoice-header div:last-child {
    margin-right: 0;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
}

.invoice-table th, .invoice-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
}

.invoice-table th {
    background-color: #f2f2f2;
}

.invoice-summary {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.invoice-summary div {
    margin-left: 20px;
}

.invoice-summary strong {
    display: block;
    margin-bottom: 5px;
}

.invoice-download {
    display: flex;
    justify-content: flex-end;
    margin-right: 80px;
}
.downloadInvoiceB{
    margin:'30px';
}
.invoice-container {
    width: 80%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border: 1px solid #ddd;
    padding: 20px;
    border-radius: 5px;
    background-color: #f9f9f9;
    position: relative; /* Ensure positioning context for alignment */
}

.invoice-actions {
    display: flex;
    justify-content: flex-end; /* Align buttons to the right */
    gap: 10px; /* Add spacing between buttons */
    margin-top: 20px; /* Add space above the actions */
    width: 80%; /* Match the width of the invoice-container */
    margin-left: auto; /* Align to the right of the container */
    margin-right: auto; /* Center horizontally within the parent */
}

.action-button {
    padding: 10px 20px;
    font-size: 14px;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.action-button:hover {
    background-color: #0056b3;
}

.action-button:active {
    background-color: #003f7f;
}

.payment-info {
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/InvQuote/InvQuoteView.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,UAAU;IACV,cAAc;IACd,8BAA8B;IAC9B,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB,EAAE,6CAA6C;AACrE;;AAEA;IACI,aAAa;IACb,yBAAyB,EAAE,+BAA+B;IAC1D,SAAS,EAAE,gCAAgC;IAC3C,gBAAgB,EAAE,gCAAgC;IAClD,UAAU,EAAE,6CAA6C;IACzD,iBAAiB,EAAE,wCAAwC;IAC3D,kBAAkB,EAAE,0CAA0C;AAClE;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".invoice-container {\n    width: 80%;\n    margin: 0 auto;\n    font-family: Arial, sans-serif;\n    border: 1px solid #ddd;\n    padding: 20px;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n}\n\n.invoice-header {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n}\n\n.invoice-header div {\n    flex: 1;\n    margin-right: 10px;\n}\n\n.invoice-header div:last-child {\n    margin-right: 0;\n}\n\n.invoice-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-bottom: 20px;\n}\n\n.invoice-table th, .invoice-table td {\n    border: 1px solid #ddd;\n    padding: 8px;\n    text-align: left;\n}\n\n.invoice-table th {\n    background-color: #f2f2f2;\n}\n\n.invoice-summary {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.invoice-summary div {\n    margin-left: 20px;\n}\n\n.invoice-summary strong {\n    display: block;\n    margin-bottom: 5px;\n}\n\n.invoice-download {\n    display: flex;\n    justify-content: flex-end;\n    margin-right: 80px;\n}\n.downloadInvoiceB{\n    margin:'30px';\n}\n.invoice-container {\n    width: 80%;\n    margin: 0 auto;\n    font-family: Arial, sans-serif;\n    border: 1px solid #ddd;\n    padding: 20px;\n    border-radius: 5px;\n    background-color: #f9f9f9;\n    position: relative; /* Ensure positioning context for alignment */\n}\n\n.invoice-actions {\n    display: flex;\n    justify-content: flex-end; /* Align buttons to the right */\n    gap: 10px; /* Add spacing between buttons */\n    margin-top: 20px; /* Add space above the actions */\n    width: 80%; /* Match the width of the invoice-container */\n    margin-left: auto; /* Align to the right of the container */\n    margin-right: auto; /* Center horizontally within the parent */\n}\n\n.action-button {\n    padding: 10px 20px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.action-button:hover {\n    background-color: #0056b3;\n}\n\n.action-button:active {\n    background-color: #003f7f;\n}\n\n.payment-info {\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
